module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Bold.0d9b62a0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Source_Sans_Pro/SourceSansPro-Bold.ttf
// module id = 77
// module chunks = 0